import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { Star } from 'lucide-react'
import { AdminShell, adminPage } from '#/components/admin/admin-shell'
import { DataTable, Pager, StatTile } from '#/components/admin/ui'
import { Badge } from '#/components/ui/badge'
import { useAdminFeedback, type AdminFeedback } from '#/lib/api-admin'
import { fmtDateTime, fmtNumber } from '#/lib/format'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/admin/feedback')({ component: adminPage(Page) })

function Page() {
  const [page, setPage] = useState(1)
  const { data, isLoading, isError, isFetching, refetch } = useAdminFeedback(page)
  return (
    <AdminShell title={m.admin_nav_feedback()} description={m.admin_feedback_desc()}>
      <div className="grid gap-3 sm:grid-cols-2">
        <StatTile label={m.admin_feedback_total()} value={data ? fmtNumber(data.total) : '…'} />
        <StatTile label={m.admin_feedback_avg()} value={data ? (data.avgRating == null ? '—' : data.avgRating.toFixed(2)) : '…'} />
      </div>
      <DataTable<AdminFeedback>
        rows={data?.feedback}
        loading={isLoading} error={isError} retrying={isFetching} onRetry={refetch}
        rowKey={(f) => f.id}
        cols={[
          { key: 'date', header: m.tx_col_date(), render: (f) => fmtDateTime(f.createdAt) },
          { key: 'rating', header: m.admin_col_rating(), render: (f) => (f.rating == null ? '—' : <span className="inline-flex items-center gap-0.5">{Array.from({ length: 5 }, (_, i) => <Star key={i} className={i < (f.rating ?? 0) ? 'size-3.5 fill-status-progress text-status-progress' : 'size-3.5 text-muted-foreground/40'} />)}</span>) },
          { key: 'msg', header: m.admin_col_message(), render: (f) => <span className="block max-w-xl whitespace-pre-wrap">{f.message ?? '—'}</span> },
          { key: 'user', header: m.admin_col_email(), render: (f) => f.userEmail ?? <span className="text-muted-foreground">{m.admin_anon()}</span> },
          { key: 'ctx', header: m.admin_col_context(), render: (f) => (f.context ? <Badge variant="outline">{f.context}</Badge> : '—') },
        ]}
      />
      {data ? <Pager page={data.page} total={data.total} pageSize={data.pageSize} onPage={setPage} /> : null}
    </AdminShell>
  )
}
